import { render, staticRenderFns } from "./topUsers.vue?vue&type=template&id=3f65fc94"
import script from "./topUsers.vue?vue&type=script&lang=js"
export * from "./topUsers.vue?vue&type=script&lang=js"
import style0 from "./topUsers.vue?vue&type=style&index=0&id=3f65fc94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports